import React, {useState} from 'react';
import { AiOutlinePlus } from "react-icons/ai"; 
import { BiTrash } from "react-icons/bi"; 
import { BiEditAlt } from "react-icons/bi"; 
import '../css/MembersTable.css';
import {cards} from '../Data/Card';
import CarteForm from '../forms/CarteForm';
import EditCardsForm from './../forms/edits/EditCardsForm';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function CardsTable() {
      const [searchTerm, setSearchTerm] = useState("");
      const [currentPage, setCurrentPage] = useState(1);
      const [itemsPerPage, setItemsPerPage] = useState(5);
      const [showModal, setShowModal] = useState(false);
      const [showEditModal, setShowEditModal] = useState(false);
      const [selectedCard, setSelectedCard] = useState({});
    
    
      const filteredData = cards.filter((card) => {
        return card.cardNo.toLowerCase().includes(searchTerm.toLowerCase());
      });
    
      const indexOfLastItem = currentPage * itemsPerPage;
      const indexOfFirstItem = indexOfLastItem - itemsPerPage;
      const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    
      const paginate = (pageNumber) => setCurrentPage(pageNumber);
    
      const handleAddNew = () => {
        setShowModal(true);
      };
    
      const handleCloseModal = () => {
        setShowModal(false);
      };
    
      const handleEditCards = (card) => {
        setSelectedCard(card);
        setShowEditModal(true);
      };
    
      const handleCloseEditModal = () => {
        setShowEditModal(false);
      };
    
      const handleUpdateCard = (updatedCard) => {
        const updatedList = cards.map((card) => {
          if (card.cardNo === selectedCard.cardNo) {
            return updatedCard;
          }
          return card;
        });
    
        setShowEditModal(false);
      };
    
      const handleDeleteCard = (card) => {
        if (window.confirm(`Voulez-vous vraiment supprimer la carte ${card.cardNo} ?`)) {
          
          toast.success(`la carte ${card.cardNo} a été supprimé avec succès !`);
        }
      };

  return (
    <div className="container mx-auto p-4">
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-lg font-bold">cartes disponible</h1>
        <div className="flex gap-2">
          <button className="btn-primary" onClick={handleAddNew}><AiOutlinePlus /> Ajouter une carte</button>
          <button className="btn-secondary">Export cartes (Excel)</button>
          <input
            type="text"
            placeholder="Rechercher une carte..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-bar"
          />
        </div>
      </div>

      <table className="table-auto w-full border-collapse border border-gray-300">
        <thead>
          <tr className="bg-gray-100">
            <th className="border border-gray-300 px-4 py-2">Numéro Carte</th>
            <th className="border border-gray-300 px-4 py-2">Date d'expiration</th>
            <th className="border border-gray-300 px-4 py-2">Balance</th>
            <th className="border border-gray-300 px-4 py-2">Catégorie</th>
            <th className="border border-gray-300 px-4 py-2">Status</th>
            <th className="border border-gray-300 px-4 py-2">Operation</th>
          </tr>
        </thead>
        <tbody>
        {currentItems.map((card, index) => (
            <tr key={index} className="text-center">
              <td className="border border-gray-300 px-4 py-2">{card.cardNo}</td>
              <td className="border border-gray-300 px-4 py-2">{card.expiryDate}</td>
              <td className="border border-gray-300 px-4 py-2">{card.balance}</td>
              <td className="border border-gray-300 px-4 py-2">{card.categoryId}</td>
              <td
                className={`border border-gray-300 px-4 py-2 ${
                  card.status === "actif" ? "text-green-500" : "text-red-500"
                }`}
              >
                {card.status}
              </td>
              <td className="border border-gray-300 px-4 py-2">
                <button className="text-blue-500 mx-1" onClick={() =>  handleEditCards(card)}><BiEditAlt /></button>
                <button className="text-red-500 mx-1" onClick={() => handleDeleteCard(card)}><BiTrash /></button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="pagination">
        {Array.from(
          { length: Math.ceil(filteredData.length / itemsPerPage) },
          (_, i) => (
            <button
              key={i + 1}
              onClick={() => paginate(i + 1)}
              className={currentPage === i + 1 ? "active" : ""}
            >
              {i + 1}
            </button>
          )
        )}
      </div>

        {showModal && (
            <div className="modal">
            <div className="modal-content">
                <button className="close-button" onClick={handleCloseModal}>
                &times;
                </button>
                <CarteForm />
            </div>
            </div>
        )}


        {showEditModal && (
            <div className="modal">
            <div className="modal-content">
                <button className="close-button" onClick={handleCloseEditModal}>
                &times;
                </button>
                <EditCardsForm card={selectedCard} handleUpdateCard={handleUpdateCard}/>
            </div>
            </div>
        )}
    </div>
  )
}

export default CardsTable